<template>
    <div ref="menuRoot" class="ppv2-relative">
        <button
            type="button"
            class="btn btn-outline-dark rounded-12 px-4 dropdown-toggle"
            :class="{ show: open }"
            aria-haspopup="true"
            :aria-expanded="open ? 'true' : 'false'"
            style="min-width: 140px"
            @click="open = !open"
        >
            {{ $t('invoices.more_options') }}
        </button>

        <div v-if="open" class="dropdown-menu show dropdown-menu-right dropdown-v3 shadow-lg" @click.stop>
            <a v-if="canModify" :href="`/back-office/v3/caisse?order=${orderId}`" class="dropdown-item poppinsRegular">
                {{ $t('invoices.modify') }}
            </a>
            <button v-if="canProforma" type="button" class="dropdown-item poppinsRegular" @click="onCreateProforma">
                {{ $t('invoices.create_proforma') }}
            </button>
            <button v-if="canCancel" type="button" class="dropdown-item poppinsRegular" @click="onCancelOrder">
                {{ $t('invoices.cancel_order') }}
            </button>
        </div>

        <order-actions-dialogs ref="orderActionsDialogs" :order-id="orderId" :order-total="orderTotal" />
    </div>
</template>

<script>
import OrderActionsDialogs from './OrderActionsDialogs.vue'

export default {
    name: 'OrderActionsMenu',
    components: {
        OrderActionsDialogs,
    },
    props: {
        orderId: {
            type: [Number, String],
            required: true,
        },
        orderTotal: {
            type: Number,
            default: 0,
        },
        suggestedDueDate: {
            type: String,
            default: null,
        },
        canModify: {
            type: Boolean,
            default: false,
        },
        canProforma: {
            type: Boolean,
            default: false,
        },
        canCancel: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: false,
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        handleClickOutside(event) {
            if (!this.open) return
            if (this.$refs.menuRoot && this.$refs.menuRoot.contains(event.target)) return
            if (event.target.closest && event.target.closest('.v-dialog')) return
            this.open = false
        },
        onCreateProforma() {
            this.open = false
            if (this.$refs.orderActionsDialogs) {
                this.$refs.orderActionsDialogs.openDeferred(null, this.suggestedDueDate)
            }
        },
        onCancelOrder() {
            this.open = false
            if (this.$refs.orderActionsDialogs) {
                this.$refs.orderActionsDialogs.requestCancel()
            }
        },
    },
}
</script>
